export default "__VITE_ASSET__BqfvOA$p__"